module.exports = __webpack_public_path__ + "static/family2-1e4975eb71118dda184983779521ceb1.png";